import { supabase } from "@/integrations/supabase/client";

export type FeatureCategory = "student_space" | "pro_space" | "navigation" | "ai_tool";

/**
 * Journalisation d'usage d'une fonctionnalité, indépendante de React.
 *
 * - Ne bloque jamais l'appelant (aucun await requis, erreurs avalées).
 * - Ignorée pour les visiteurs anonymes (RLS : insertion réservée au propriétaire).
 * - Anti-doublon : un même événement n'est enregistré qu'une fois toutes les 2 secondes.
 */
const lastSeen = new Map<string, number>();
const DEDUPE_MS = 2000;

export function trackFeature(
  eventName: string,
  eventCategory: FeatureCategory,
  metadata?: Record<string, string | number | boolean>,
): void {
  const key = `${eventCategory}:${eventName}`;
  const now = Date.now();
  const previous = lastSeen.get(key);
  if (previous !== undefined && now - previous < DEDUPE_MS) return;
  lastSeen.set(key, now);

  void (async () => {
    try {
      const { data } = await supabase.auth.getSession();
      const userId = data.session?.user?.id;
      if (!userId) return;
      const { error } = await supabase.from("feature_events").insert([
        {
          user_id: userId,
          event_name: eventName,
          event_category: eventCategory,
          metadata: (metadata ?? {}) as Record<string, string | number | boolean>,
        },
      ]);
      if (error) console.warn("Feature tracking error:", error.message);
    } catch {
      /* le suivi ne doit jamais interrompre l'expérience */
    }
  })();
}
